import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createHead } from '@unhead/vue'

import PrimeVue from 'primevue/config'
import primelocale from 'primelocale/de.json'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'

import './styles/main.scss'

// Import PrimeVue theme
import './styles/primevue-theme/theme.scss'
import 'primeicons/primeicons.css'

import App from './app.vue'
import Filter from './routes/Filter.vue'
import Person from './routes/Person.vue'

// The initialization function of the plugin, receiving a target element
// and the options defined in the config file as <Shell> root props.
export default async function (element: HTMLElement, options: Record<string, any> = {}) {
  const app = createApp(App)

  app.provide('options', options)

  app.use(createPinia())

  app.use(createHead())

  const history = createWebHistory(options.base)
  app.provide('history', history)

  const router = createRouter({
    history,
    routes: [
      { path: '/', component: Filter, name: 'list' },
      { path: '/person/:id(Q[a-zA-Z0-9]+)', component: Person, name: 'person' },
    ],
  })

  app.use(router)

  app.use(PrimeVue, {
    // unstyled: true
    locale: primelocale.de,
    // https://primevue.org/passthrough/#customcss
    pt: {
      global: {
        css:
          // language=css
          `
	 		.p-dialog-mask {
	 			backdrop-filter: blur(12px);
	 		}
			`,
      },
    },
  })
  app.directive('tooltip', Tooltip)
  app.use(ToastService)

  // Mount application
  app.mount(element)
}
